import clsx from 'clsx';
import type React from 'react';

export function IconTile({
    children,
    size,
    bordered = true,
    className,
}: {
    children: React.ReactNode;
    size?: number;
    bordered?: boolean;
    className?: string;
}) {
    return (
        <div
            className={clsx(
                'relative flex items-center justify-center border',
                getSizeClasses(size ?? 32),
                !bordered && 'border-transparent',
                className
            )}
            style={{ width: size, height: size }}
        >
            {children}
        </div>
    );
}

function getSizeClasses(size: number) {
    if (size >= 48) {
        return 'p-2 rounded-lg';
    }
    if (size >= 32) {
        return 'p-1 rounded-md';
    }
    return 'p-0.5 rounded-sm';
}
